import { takeEvery } from 'redux-saga/effects';
import { saveLayer } from './save-layer';
import { newEmptyLayer } from './new-empty-layer';
import { deleteLayer } from './delete-layer';
import { fetchCustomLayers } from './fetch-custom-layers';
import { fetchShareLayerOptions } from './fetch-share-layer-options';
import { shareLayer } from './share-layer';
import { deleteShareLayer } from './delete-share-layer';

export function* fetchCustomLayersSaga() {
  yield takeEvery(['FETCH_CUSTOM_LAYERS'], fetchCustomLayers);
}
export function* saveLayerSaga() {
  yield takeEvery(['SAVE_NEW_LAYER'], saveLayer);
}
export function* newEmptyLayerSaga() {
  yield takeEvery(['CREATE_NEW_EMPTY_CUSTOM_LAYERS'], newEmptyLayer);
}
export function* deleteLayerSaga() {
  yield takeEvery(['REMOVE_CUSTOM_LAYERS'], deleteLayer);
}
export function* fetchShareLayerOptionsSaga() {
  yield takeEvery(['FETCH_SHARE_LAYER_OPTIONS'], fetchShareLayerOptions);
}
export function* shareLayerSaga() {
  yield takeEvery(['SHARE_LAYER'], shareLayer);
}
export function* deleteShareLayerSaga() {
  yield takeEvery(['DELETE_SHARE_LAYER'], deleteShareLayer);
}